export const Dzyarzhynsk = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.487399169372452, 53.6511270765447],
            [27.486081924162818, 53.65356686143366],
            [27.485106767887657, 53.6572270027595],
            [27.48413161161244, 53.66050159654941],
            [27.482246309240793, 53.66585597258302],
            [27.481206142786846, 53.66943031371858],
            [27.48016597543443, 53.67214168092187],
            [27.478917775330274, 53.67719421734955],
            [27.47870974257853, 53.682122937556414],
            [27.477045475174123, 53.6856958992916],
            [27.473092842109907, 53.687913446989626],
            [27.467267907991186, 53.68803664083708],
            [27.461442973872522, 53.68803664083708],
            [27.456658207106045, 53.68815983379233],
            [27.45208147309154, 53.69013087790654],
            [27.45083327298738, 53.69271773304786],
            [27.451249339389335, 53.695797115439746],
            [27.45062523933717, 53.69838362242382],
            [27.44625653897282, 53.70010787193888],
            [27.4400155384522, 53.70035418791184],
            [27.433150437879362, 53.69998471394365],
            [27.426701403708705, 53.69986155505626],
            [27.42025236953782, 53.70047734482603],
            [27.416299735575308, 53.70207835670021],
            [27.411098902406877, 53.70491076648216],
            [27.40756233484649, 53.70909745827271],
            [27.40485790188643, 53.71254500934435],
            [27.405482001938424, 53.71574605399968],
            [27.40943463500264, 53.71894685454271],
            [27.414635469069196, 53.72030096596126],
            [27.419628269485827, 53.72190122363429],
            [27.425037137202594, 53.72362450958644],
            [27.427949603812692, 53.7262093069038],
            [27.428365670214646, 53.729409311184895],
            [27.425037137202594, 53.733839684526345],
            [27.423164837046386, 53.736054696111694],
            [27.419836303135867, 53.740115247539904],
            [27.41858810303171, 53.74306812945275],
            [27.41858810303171, 53.74515962895879],
            [27.422540736994222, 53.7472510238328],
            [27.424829103552327, 53.749834368116694],
            [27.4258692700065, 53.75340158277265],
            [27.42358090344834, 53.757706437838124],
            [27.41858810303171, 53.76127298402042],
            [27.41172300245904, 53.76459328890019],
            [27.40423380093597, 53.766683716364355],
            [27.391959833544718, 53.76938882134863],
            [27.387383099530155, 53.77024950013981],
            [27.378853732451432, 53.77037245243315],
            [27.369700264422193, 53.77147901005378],
            [27.365747630459623, 53.77418380606389],
            [27.363875330303472, 53.779347023236255],
            [27.364915497655716, 53.78155963668445],
            [27.36803599791608, 53.78364921936543],
            [27.372612731930758, 53.784140870974625],
            [27.379269798853386, 53.78586160544398],
            [27.383430465567642, 53.790040238822144],
            [27.382598332763735, 53.794464220336806],
            [27.37614929859302, 53.7980276437321],
            [27.3690761643702, 53.79839625647651],
            [27.36241909744757, 53.797044660750146],
            [27.359090563537052, 53.79507862513498],
            [27.355553995976493, 53.79065470842431],
            [27.350977262860226, 53.78782807309085],
            [27.345776428793556, 53.7856157907064],
            [27.339327394622842, 53.78512415637971],
            [27.334750660608165, 53.78463251629233],
            [27.328093593685537, 53.78487833732146],
            [27.32518112707544, 53.785738697989814],
            [27.32455702612515, 53.788934170538084],
            [27.326429327179596, 53.793481153832715],
            [27.326013259879346, 53.79815051518375],
            [27.325597193477392, 53.801345042324726],
            [27.32185259316492, 53.802942214107475],
            [27.314987492592252, 53.80306507115944],
            [27.30791435836943, 53.80257364132183],
            [27.30208942425071, 53.80245078336037],
            [27.295224323677928, 53.803556495237444],
            [27.292311856169476, 53.80478502943822],
            [27.28794315580501, 53.80847041711962],
            [27.285446755596695, 53.81141849454161],
            [27.285446755596695, 53.814243540167695],
            [27.28503068919474, 53.819770252999774],
            [27.28523872284495, 53.82148952647714],
            [27.281286088882382, 53.82284033426737],
            [27.27962182237627, 53.823208728882264],
            [27.269636220644827, 53.82455948124806],
            [27.26651572038469, 53.825541819734894],
            [27.264227353826584, 53.82824313101571],
            [27.26547555393057, 53.83069871705669],
            [27.269220154243044, 53.8348728834452],
            [27.270676387997298, 53.83880113028647],
            [27.269636220644827, 53.843219967741675],
            [27.267139820436682, 53.84444734000772],
            [27.261106853566105, 53.84555194412383],
            [27.255281919447384, 53.84763833940099],
            [27.25257748558903, 53.848742859322556],
            [27.248416818874773, 53.85009278836117],
            [27.238431218041626, 53.85181081694952],
            [27.232606283922905, 53.85193353076818],
            [27.226157249752248, 53.853160647576374],
            [27.220540349283567, 53.85500125506502],
            [27.21117884850264, 53.85708717885103],
            [27.205769980785874, 53.859663764906315],
            [27.19869684746135, 53.86076796750592],
            [27.195368313550773, 53.86015452539135],
            [27.189959445834063, 53.85806875450419],
            [27.187046979223737, 53.85598287911654],
            [27.183302378911435, 53.853651483801684],
            [27.179141711298882, 53.85181081694952],
            [27.1749810445844, 53.85082909503831],
            [27.17186054432409, 53.851442673864995],
            [27.167491843959624, 53.85303793735551],
            [27.165827577453683, 53.85549206970404],
            [27.163955276399008, 53.85843683930557],
            [27.1608347761387, 53.8619948252836],
            [27.152097375409937, 53.862976285286265],
            [27.147520641395204, 53.86174945681796],
            [27.14398407473294, 53.85941838277017],
            [27.139615374368645, 53.85671908217739],
            [27.137327007810313, 53.854878550240926],
            [27.133582406599714, 53.85230166953528],
            [27.12838157343134, 53.85021550721683],
            [27.121100405558423, 53.84960190987056],
            [27.114651371387538, 53.85082909503831],
            [27.10861840451713, 53.85230166953528],
            [27.101961337594503, 53.852669805064465],
            [27.09572033617559, 53.853651483801684],
            [27.08386243518629, 53.85573747539485],
            [27.07637323456146, 53.85892761365096],
            [27.072212567847203, 53.864448432386496],
            [27.072628634249156, 53.86837390508947],
            [27.072836667899196, 53.87180839140791],
            [27.072420600598946, 53.87462936530915],
            [27.07325273430115, 53.877082231930956],
            [27.074084868003354, 53.88137440153167],
            [27.072420600598946, 53.88443996751232],
            [27.06992420039063, 53.88615658600003],
            [27.06264303341601, 53.887505308709194],
            [27.05556989919313, 53.88726008934634],
            [27.049120865022473, 53.886401811836436],
            [27.04641643116412, 53.88615658600003],
            [27.04183969804768, 53.88517566985706],
            [27.03663886398118, 53.883459010558795],
            [27.0310219635125, 53.88161965489172],
            [27.024364895691633, 53.87953495414973],
            [27.01999619532711, 53.87867651750014],
            [27.016251595014808, 53.88027074281348],
            [27.0168756950668, 53.88284590117115],
            [27.018331928821, 53.88505305352237],
            [27.02249259553531, 53.889099196854716],
            [27.02415686293972, 53.89167381142482],
            [27.02769342960198, 53.895351557656454],
            [27.027069329549988, 53.9046670651328],
            [27.0272773632002, 53.907976021676745],
            [27.027105224318234, 53.91172776919154],
            [27.02675225479743, 53.91151986734417],
            [27.017378040160168, 53.908364474094526],
            [27.010235781474535, 53.907575588533405],
            [27.00711104386096, 53.907575588533405],
            [26.999522394344353, 53.90783855186612],
            [26.99461209161035, 53.909416298155804],
            [26.991487353098535, 53.91257161194261],
            [26.99014817970715, 53.915989599888974],
            [26.987023442093744, 53.91730413618569],
            [26.98032757513738, 53.91625251024732],
            [26.97764922745654, 53.91388625584],
            [26.976756445794592, 53.908364474094526],
            [26.974524489842963, 53.90363093669856],
            [26.97139975133109, 53.90047494744675],
            [26.9651502752057, 53.89600355437386],
            [26.960686364200967, 53.89311004498694],
            [26.95532967063582, 53.889953260983646],
            [26.949526585341573, 53.88653314221665],
            [26.945509065167755, 53.88627004477007],
            [26.94059876243358, 53.88679623800749],
            [26.93658124225982, 53.88942710695824],
            [26.930331766134373, 53.89100554863501],
            [26.9249750716711, 53.89100554863501],
            [26.91872559554571, 53.89047940785639],
            [26.913815292811535, 53.88942710695824],
            [26.908012208415585, 53.8854807419649],
            [26.90711942585517, 53.882849624624725],
            [26.90711942585517, 53.87916578245847],
            [26.909797772637717, 53.8767974269208],
            [26.914261684540975, 53.87442893723909],
            [26.914708075371948, 53.87048115579836],
            [26.91247611942032, 53.865480098526405],
            [26.909351381806744, 53.86258447601131],
            [26.90220912312111, 53.856792629714164],
            [26.89819160294735, 53.85336979809529],
            [26.89055144549451, 53.85048544453059],
            [26.89660244997208, 53.84707105676125],
            [26.901173495854152, 53.84420576407655],
            [26.90317332803471, 53.842014525051866],
            [26.9057445408381, 53.836283050863244],
            [26.9057445408381, 53.82937052396926],
            [26.909458515785957, 53.82599814588866],
            [26.914600941392735, 53.82346868363368],
            [26.922314580701368, 53.82127635994118],
            [26.929742529698558, 53.82043312797708],
            [26.933456503747948, 53.82009583043998],
            [26.93945600118758, 53.81925257471892],
            [26.94316997523714, 53.81722869122291],
            [26.946026878351915, 53.81537337930405],
            [26.94631256866353, 53.81098776954872],
            [26.944027046171527, 53.807951309728764],
            [26.94059876243358, 53.80525204915335],
            [26.93745616900719, 53.80086538037881],
            [26.938027549630192, 53.79698448359642],
            [26.937741859318635, 53.79344074189794],
            [26.93517064561695, 53.788715287368916],
            [26.93259943281356, 53.78365171020778],
            [26.929742529698558, 53.77993803134859],
            [26.92831407814117, 53.775886370521505],
            [26.926885625685316, 53.7718343190632],
            [26.92288596132437, 53.7677818758948],
            [26.917457845405977, 53.76491115847563],
            [26.908315754539956, 53.759844708668936],
            [26.902601947411767, 53.75460873446718],
            [26.899173663673764, 53.74835849149474],
            [26.89688814118182, 53.74210731855152],
            [26.894316927480133, 53.73467228022412],
            [26.892602785611132, 53.73230631071419],
            [26.888031740627355, 53.72943316870868],
            [26.88288931412211, 53.72588372165808],
            [26.880889481941722, 53.72199588826754],
            [26.88403207536811, 53.71743145189754],
            [26.890031572807743, 53.71219019129495],
            [26.898602283050764, 53.70576452942498],
            [26.9051731602151, 53.70339693259973],
            [26.912601109212346, 53.699845288389895],
            [26.91774353571759, 53.69510929599073],
            [26.91688646388468, 53.69088028098872],
            [26.913458180146733, 53.68698921193118],
            [26.908887135162956, 53.6844513648133],
            [26.902887637723325, 53.681744159301275],
            [26.898887973362378, 53.678359907149684],
            [26.89603106934908, 53.67142134066211],
            [26.89803090242782, 53.66651288389397],
            [26.898602283050764, 53.662280996630216],
            [26.899745044296765, 53.6551704696937],
            [26.901459186165766, 53.649074777527744],
            [26.902887637723325, 53.643994360725515],
            [26.9063159214611, 53.63959083819327],
            [26.910029896408957, 53.63654197581434],
            [26.915743702638736, 53.632645886681075],
            [26.91774353571759, 53.62858001931011],
            [26.91831491634042, 53.61383796403976],
            [26.916029392950293, 53.596038971153064],
            [26.91488663170429, 53.58756062388403],
            [26.912315418900732, 53.58399921041962],
            [26.9091728254744, 53.581455160299356],
            [26.904887469903713, 53.57755398551649],
            [26.9051731602151, 53.573822090656165],
            [26.9097442060974, 53.57076847658573],
            [26.915743702638736, 53.56924158712235],
            [26.922314580701368, 53.56941124422974],
            [26.93002822001, 53.57008986585265],
            [26.935742026239893, 53.56754497861391],
            [26.93945600118758, 53.562115373454276],
            [26.940884452745138, 53.55396965852117],
            [26.942312904302582, 53.54735011059569],
            [26.946026878351915, 53.54412482778014],
            [26.95116930485716, 53.53920155330849],
            [26.955272473835635, 53.53464961517466],
            [26.957084712799656, 53.535607015938695],
            [26.961872705416283, 53.537639549197706],
            [26.966318699522844, 53.54028169694027],
            [26.972474690671504, 53.54231400578965],
            [26.976578684471235, 53.541704323539534],
            [26.980682678270796, 53.53702979962526],
            [26.982050676803, 53.5313383785458],
            [26.983760673845097, 53.52605280297087],
            [26.989916664993757, 53.52117322401983],
            [26.99744065377638, 53.523206450092516],
            [26.997782653184686, 53.52727260948234],
            [26.997782653184686, 53.533980919506234],
            [27.00051864935068, 53.53581027413577],
            [27.006332641090808, 53.5341841849754],
            [27.01043663489054, 53.528898964052814],
            [27.013514630464897, 53.524223026800996],
            [27.017276624856265, 53.523206450092516],
            [27.023774615413288, 53.52706931083668],
            [27.031640604502513, 53.532558033367366],
            [27.034376599770212, 53.53621678653519],
            [27.04019059151034, 53.536623295031745],
            [27.04532058443374, 53.53520049768497],
            [27.053870571441564, 53.532558033367366],
            [27.056948567015922, 53.52808579484099],
            [27.059342563773384, 53.52178320192803],
            [27.058316565547955, 53.51629308349595],
            [27.056264568199026, 53.512225869605686],
            [27.052160574399295, 53.5083616558004],
            [27.045662583842272, 53.50246296515758],
            [27.043952585901707, 53.49615656008871],
            [27.045662583842272, 53.49290127488746],
            [27.054212570850098, 53.49066312118316],
            [27.06891854990488, 53.48964573925099],
            [27.07917853485327, 53.48984921748297],
            [27.090122518618557, 53.490866594534],
            [27.096278509767217, 53.49391857819023],
            [27.094910512133424, 53.50083559560363],
            [27.08943851980166, 53.50592091744409],
            [27.083966527469897, 53.5112090055361],
            [27.080204533078472, 53.51486960306681],
            [27.07815253662784, 53.52015657465512],
            [27.07815253662784, 53.52483296079549],
            [27.083966527469897, 53.52727260948234],
            [27.090464518026863, 53.52706931083668],
            [27.096962508584056, 53.52279981279179],
            [27.097988507707782, 53.52015657465512],
            [27.10346049914125, 53.51507296026546],
            [27.108590492064536, 53.51344607481633],
            [27.117824478787668, 53.51405616397915],
            [27.121244473770332, 53.51507296026546],
            [27.126716465203856, 53.51893656267907],
            [27.12842646314442, 53.52198652594575],
            [27.123638469629498, 53.52666271061793],
            [27.122954470812658, 53.531135099416076],
            [27.123296470220964, 53.53520049768497],
            [27.127058465510686, 53.53967198488607],
            [27.13321445576105, 53.53967198488607],
            [27.140396446033378, 53.5372330504585],
            [27.14450043983311, 53.53459071298647],
            [27.153050426840935, 53.53194821061453],
            [27.16091641593016, 53.53174493387792],
            [27.17425439645291, 53.53174493387792],
            [27.18109438641841, 53.532354760092005],
            [27.188276375792498, 53.53337111671044],
            [27.195116365757997, 53.53621678653519],
            [27.20093035749835, 53.539468745761155],
            [27.207428348055316, 53.540484932162315],
            [27.214268338021043, 53.54028169694027],
            [27.220766328578236, 53.53865577950506],
            [27.2241863235609, 53.535403757299775],
            [27.223844324152367, 53.53174493387792],
            [27.219740330352863, 53.52808579484099],
            [27.214610337429406, 53.52666271061793],
            [27.20982234481278, 53.524223026800996],
            [27.206402349830114, 53.51995324132042],
            [27.20777034746385, 53.516089731619104],
            [27.21392633861251, 53.51303934382804],
            [27.221450327395132, 53.50998873591084],
            [27.22521232178633, 53.50897181816174],
            [27.23136831293499, 53.50998873591084],
            [27.238892301717385, 53.51344607481633],
            [27.24231229670022, 53.51547967173474],
            [27.253598280772337, 53.51751317105902],
            [27.261464268963266, 53.5164964338631],
            [27.273434251852052, 53.5164964338631],
            [27.280958240634675, 53.51751317105902],
            [27.287114231783335, 53.51832654378342],
            [27.291218225583066, 53.51995324132042],
            [27.291560224991372, 53.52442633910846],
            [27.291902224399905, 53.528898964052814],
            [27.294296221157367, 53.535607015938695],
            [27.294980219974263, 53.53987522356903],
            [27.30079421171456, 53.54475264751534],
            [27.306266204046153, 53.54515907405505],
            [27.31002819843758, 53.54251723125509],
            [27.309344199620682, 53.537842797637666],
            [27.30900220021215, 53.53296457699031],
            [27.31105419666295, 53.52625610649562],
            [27.31481619105415, 53.52279981279179],
            [27.32097218220281, 53.52178320192803],
            [27.3254181763092, 53.52198652594575],
            [27.335336161849227, 53.523816398724705],
            [27.34764814324825, 53.52666271061793],
            [27.36201212289467, 53.531541656699744],
            [27.371246109617687, 53.53642004127124],
            [27.376718101051154, 53.53967198488607],
            [27.384926089548742, 53.54617512386466],
            [27.390740080390742, 53.55227090893021],
            [27.39655407213087, 53.55613111873407],
            [27.40202606446269, 53.56060039522487],
            [27.40818205561152, 53.5634442348333],
            [27.418784039968273, 53.56669410245223],
            [27.42152003613421, 53.56974062713044],
            [27.424256032300036, 53.574208465853076],
            [27.424256032300036, 53.57664526977669],
            [27.422204034951108, 53.58030021259901],
            [27.419810038193646, 53.58050325565375],
            [27.416048043802448, 53.58030021259901],
            [27.411602050594183, 53.58009716856924],
            [27.407156056487793, 53.580909339370805],
            [27.405788058854057, 53.584563913012744],
            [27.40510406003716, 53.58801516522175],
            [27.403394062096595, 53.593090024182516],
            [27.40442006122015, 53.59694650923899],
            [27.40818205561152, 53.60100558685417],
            [27.413312047636452, 53.605064274452275],
            [27.419810038193646, 53.607702212092704],
            [27.424940031116932, 53.60851385243251],
            [27.432122020490965, 53.608919666486145],
            [27.43759401282273, 53.60993418455854],
            [27.43964600927353, 53.611963148115535],
            [27.43896201045652, 53.61622365472829],
            [27.434516017248427, 53.62109227794667],
            [27.4304120225504, 53.62332354264265],
            [27.430070023142036, 53.62677162904856],
            [27.427334027874338, 53.631233440026676],
            [27.422888033768004, 53.63488366193718],
            [27.420836037317372, 53.63812803863925],
            [27.42254603435947, 53.644007835125194],
            [27.429044024916664, 53.64644061448058],
            [27.43485801665696, 53.6490759670383],
            [27.44682799864762, 53.65211655424963],
            [27.45742998390267, 53.6539408012232],
            [27.467347969442528, 53.653332727846475],
            [27.474187959408255, 53.652724645167154],
            [27.481369948782287, 53.65130575271655],
            [27.487399169372452, 53.6511270765447],
          ],
        ],
      },
      properties: {
        shapeName: "Dzyarzhynsk",
        shapeISO: "",
        shapeID: "67162791B81421428715601",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
